import script from "./FocusModeModalMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./FocusModeModalMain.vue?vue&type=script&setup=true&lang=ts"

import "./FocusModeModalMain.vue?vue&type=style&index=0&id=45d7794a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d7794a"]])

export default __exports__